import EFPicture from '@elem/compCommon/EFPicture';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';

export default function ModuleDesign() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('theProduct.ModuleDesign');

    const { locale } = useRouter();
    const cards = new Array(9).fill(1);

    const IMGS = [
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1731898403023/125w_design_card_1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1731924085213/125w_design_card_1_h5.jpg',
            title: t('module_design_card_1_title'),
            desc: t('module_design_card_1_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1731898403908/125w_design_card_2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1731924088236/125w_design_card_2_h5.jpg',
            title: t('module_design_card_2_title'),
            desc: t('module_design_card_2_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1731898404355/125w_design_card_3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1731924088753/125w_design_card_3_h5.jpg',
            title: t('module_design_card_3_title'),
            desc: t('module_design_card_3_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1731898404572/125w_design_card_4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1731924089486/125w_design_card_4_h5.jpg',
            title: t('module_design_card_4_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1731898404758/125w_design_card_5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1731924085480/125w_design_card_5_h5.jpg',
            title: t('module_design_card_5_title'),
            desc: t('module_design_card_5_desc_1'),
            desc2: t('module_design_card_5_desc_2'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1731898403216/125w_design_card_6.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1731924086471/125w_design_card_6_h5.jpg',
            title: t('module_design_card_6_title'),
            desc: t('module_design_card_6_desc'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1731898404120/125w_design_card_7.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1731924085866/125w_design_card_7_h5.jpg',
            title: t('module_design_card_7_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1731898403705/125w_design_card_8.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1731924086297/125w_design_card_8_h5.jpg',
            title: t('module_design_card_8_title'),
        },
        {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1731898403413/125w_design_card_9.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1731924087213/125w_design_card_9_h5.jpg',
            title: t('module_design_card_9_title'),
            desc: t('module_design_card_9_desc'),
        },
    ];
    // sp-125w-common
    return (
        <div className={`${styles.TheComp} ${styles.moduleDesignComponent} sp-125w-common`}>
            <EfSpec />
            <EfTitle hasAnimation={false}>{t('module_design_title')}</EfTitle>

            <div className="cards-list">
                <div className="card-col card-col-1">
                    <div className={`card-item card-item-1 card-item-bottom-center`}>
                        <div className="text">
                            <p className="text-title">{IMGS['0']?.title}</p>
                            {IMGS['0']?.desc && <p className="text-desc">{IMGS['0']?.desc}</p>}
                        </div>
                        <div className="card-img">
                            <EFPicture src={IMGS['0'].pc} srcPad={IMGS['0'].h5} srcMobile={IMGS['0'].h5} alt={t('B_tip')} />
                        </div>
                    </div>
                    <div className={`card-item card-item-4 card-item-bottom-center`}>
                        <div className="text">
                            <p className="text-title">{IMGS['3']?.title}</p>
                            {IMGS['3']?.desc && <p className="text-desc">{IMGS['3']?.desc}</p>}
                        </div>
                        <div className="card-img">
                            <EFPicture src={IMGS['3'].pc} srcPad={IMGS['3'].h5} srcMobile={IMGS['3'].h5} alt={t('B_tip')} />
                        </div>
                    </div>
                    <div className={`card-item card-item-6`}>
                        <div className="text">
                            <p className="text-title">{IMGS['5']?.title}</p>
                            {IMGS['5']?.desc && <p className="text-desc">{IMGS['5']?.desc}</p>}
                        </div>
                        <div className="card-img">
                            <EFPicture src={IMGS['5'].pc} srcPad={IMGS['5'].h5} srcMobile={IMGS['5'].h5} alt={t('B_tip')} />
                        </div>
                    </div>
                </div>
                <div className="card-col card-col-2">
                    <div className="card-row card-row-1">
                        <div className={`card-item card-item-2`}>
                            <div className="text">
                                <p className="text-title">{IMGS['1']?.title}</p>
                                {IMGS['1']?.desc && <p className="text-desc">{IMGS['1']?.desc}</p>}
                            </div>
                            <div className="card-img">
                                <EFPicture src={IMGS['1'].pc} srcPad={IMGS['1'].h5} srcMobile={IMGS['1'].h5} alt={t('B_tip')} />
                            </div>
                        </div>
                        <div className="card-col card-col-3">
                            <div className={`card-item card-item-3`}>
                                <div className="text">
                                    <p className="text-title">{IMGS['2']?.title}</p>
                                    {IMGS['2']?.desc && <p className="text-desc">{IMGS['2']?.desc}</p>}
                                </div>
                                <div className="card-img">
                                    <EFPicture src={IMGS['2'].pc} srcPad={IMGS['2'].h5} srcMobile={IMGS['2'].h5} alt={t('B_tip')} />
                                </div>
                            </div>
                            <div className={`card-item card-item-5`}>
                                <div className="text">
                                    <p className="text-title">{IMGS['4']?.title}</p>
                                    {IMGS['4']?.desc && <p className="text-desc">{IMGS['4']?.desc}</p>}
                                    {IMGS['4']?.desc2 && <p className="text-desc-2">{IMGS['4']?.desc2}</p>}
                                </div>
                                <div className="card-img">
                                    <EFPicture src={IMGS['4'].pc} srcPad={IMGS['4'].h5} srcMobile={IMGS['4'].h5} alt={t('B_tip')} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card-row card-row-2">
                        <div className={`card-item card-item-7`}>
                            <div className="text">
                                <p className="text-title">{IMGS['6']?.title}</p>
                                {IMGS['6']?.desc && <p className="text-desc">{IMGS['6']?.desc}</p>}
                            </div>
                            <div className="card-img">
                                <EFPicture src={IMGS['6'].pc} srcPad={IMGS['6'].h5} srcMobile={IMGS['6'].h5} alt={t('B_tip')} />
                            </div>
                        </div>
                        <div className={`card-item card-item-8 card-item-bottom-center`}>
                            <div className="text">
                                <p className="text-title">{IMGS['7']?.title}</p>
                                {IMGS['7']?.desc && <p className="text-desc">{IMGS['7']?.desc}</p>}
                            </div>
                            <div className="card-img">
                                <EFPicture src={IMGS['7'].pc} srcPad={IMGS['7'].h5} srcMobile={IMGS['7'].h5} alt={t('B_tip')} />
                            </div>
                        </div>
                        <div className={`card-item card-item-9`}>
                            <div className="text">
                                <p className="text-title">{IMGS['8']?.title}</p>
                                {IMGS['8']?.desc && <p className="text-desc">{IMGS['8']?.desc}</p>}
                            </div>
                            <div className="card-img">
                                <EFPicture src={IMGS['8'].pc} srcPad={IMGS['8'].h5} srcMobile={IMGS['8'].h5} alt={t('B_tip')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="cards-list-h5">
                <div className={`card-item card-item-2`}>
                    <div className="text">
                        <p className="text-title">{IMGS['1']?.title}</p>
                        {IMGS['1']?.desc && <p className="text-desc">{IMGS['1']?.desc}</p>}
                    </div>
                    <div className="card-img">
                        <EFPicture src={IMGS['1'].pc} srcPad={IMGS['1'].h5} srcMobile={IMGS['1'].h5} alt={t('B_tip')} />
                    </div>
                </div>

                <div className="card-row card-row-1">
                    <div className={`card-item card-item-5`}>
                        <div className="text">
                            <p className="text-title">{IMGS['4']?.title}</p>
                            {IMGS['4']?.desc && <p className="text-desc">{IMGS['4']?.desc}</p>}
                            {IMGS['4']?.desc2 && <p className="text-desc-2">{IMGS['4']?.desc2}</p>}
                        </div>
                        <div className="card-img">
                            <EFPicture src={IMGS['4'].pc} srcPad={IMGS['4'].h5} srcMobile={IMGS['4'].h5} alt={t('B_tip')} />
                        </div>
                    </div>
                    <div className={`card-item card-item-1`}>
                        <div className="text">
                            <p className="text-title">{IMGS['0']?.title}</p>
                            {IMGS['0']?.desc && <p className="text-desc">{IMGS['0']?.desc}</p>}
                        </div>
                        <div className="card-img">
                            <EFPicture src={IMGS['0'].pc} srcPad={IMGS['0'].h5} srcMobile={IMGS['0'].h5} alt={t('B_tip')} />
                        </div>
                    </div>
                </div>
                <div className="card-row card-row-2">
                    <div className={`card-item card-item-6`}>
                        <div className="text">
                            <p className="text-title">{IMGS['5']?.title}</p>
                            {IMGS['5']?.desc && <p className="text-desc">{IMGS['5']?.desc}</p>}
                        </div>
                        <div className="card-img">
                            <EFPicture src={IMGS['5'].pc} srcPad={IMGS['5'].h5} srcMobile={IMGS['5'].h5} alt={t('B_tip')} />
                        </div>
                    </div>
                    <div className={`card-item card-item-7`}>
                        <div className="text">
                            <p className="text-title">{IMGS['6']?.title}</p>
                            {IMGS['6']?.desc && <p className="text-desc">{IMGS['6']?.desc}</p>}
                        </div>
                        <div className="card-img">
                            <EFPicture src={IMGS['6'].pc} srcPad={IMGS['6'].h5} srcMobile={IMGS['6'].h5} alt={t('B_tip')} />
                        </div>
                    </div>
                </div>
                <div className="card-row card-row-3">
                    <div className={`card-item card-item-3`}>
                        <div className="text">
                            <p className="text-title">{IMGS['2']?.title}</p>
                            {IMGS['2']?.desc && <p className="text-desc">{IMGS['2']?.desc}</p>}
                        </div>
                        <div className="card-img">
                            <EFPicture src={IMGS['2'].pc} srcPad={IMGS['2'].h5} srcMobile={IMGS['2'].h5} alt={t('B_tip')} />
                        </div>
                    </div>
                    <div className={`card-item card-item-9`}>
                        <div className="text">
                            <p className="text-title">{IMGS['8']?.title}</p>
                            {IMGS['8']?.desc && <p className="text-desc">{IMGS['8']?.desc}</p>}
                        </div>
                        <div className="card-img">
                            <EFPicture src={IMGS['8'].pc} srcPad={IMGS['8'].h5} srcMobile={IMGS['8'].h5} alt={t('B_tip')} />
                        </div>
                    </div>
                </div>
                <div className="card-row card-row-4">
                    <div className={`card-item card-item-4`}>
                        <div className="text">
                            <p className="text-title">{IMGS['3']?.title}</p>
                            {IMGS['3']?.desc && <p className="text-desc">{IMGS['3']?.desc}</p>}
                        </div>
                        <div className="card-img">
                            <EFPicture src={IMGS['3'].pc} srcPad={IMGS['3'].h5} srcMobile={IMGS['3'].h5} alt={t('B_tip')} />
                        </div>
                    </div>
                    <div className={`card-item card-item-8`}>
                        <div className="text">
                            <p className="text-title">{IMGS['7']?.title}</p>
                            {IMGS['7']?.desc && <p className="text-desc">{IMGS['7']?.desc}</p>}
                        </div>
                        <div className="card-img">
                            <EFPicture src={IMGS['7'].pc} srcPad={IMGS['7'].h5} srcMobile={IMGS['7'].h5} alt={t('B_tip')} />
                        </div>
                    </div>
                </div>
            </div>

            <EfSpec />
        </div>
    );
}
